// extracted by mini-css-extract-plugin
export default {"input":"oGVU0FLX","wrapper":"A30TUVBr","checkbox":"hVrm_rpS","check":"DZnaeMgb","minus":"VxMX3jZn","checked":"wH33qoK9"};